export const DISTRIBUTOR_BRAND_FILTER_KEY_V2 = 'manufacturer_names'
export const EXHIBITOR_FILTER_KEY_V2 = 'exhibitor_org_id'
export const FEATURE_CONFIG_BRAND_FILTER_NODE_KEY_V2 = 'feature_config_brand_filter'
export const MANUFACTURER_FILTER_KEY_V2 = 'manufacturer'
